module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img59.6fe2e29d.jpg";